export default __webpack_public_path__ + "static/plan-16-meal-rollover-35ae89b5ae54387a2936d9e105825ecb.png";